/**
 * @file UsageRing.ts
 * @brief Dashboard's own icon: a usage ring with bars inside (was lucide LayoutDashboard).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/UsageRing.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const UsageRing = createLucideIcon("UsageRing", [
  // Three quarters of the ring, top round to the right.
  ["path", { d: "M12 2a10 10 0 1 0 10 10", key: "ring" }],
  // The lifted segment, on the same circle, with a gap either side.
  ["path", { d: "M15.32 2.57A10 10 0 0 1 21.43 8.68", key: "segment" }],
  ["path", { d: "M8.5 15v-3", key: "bar-1" }],
  ["path", { d: "M12 15v-6", key: "bar-2" }],
  ["path", { d: "M15.5 15v-4", key: "bar-3" }],
]);

export default UsageRing;
